import { PropsWithChildren, ReactNode } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import { segmentsActions } from 'common/filter/actions/segmentsActions'
import { getSegments } from 'common/filter/selectors/segmentsSelectors'
import { useDidMountEffect } from 'utils/commonHooks'

interface EnsureSegmentsProps extends PropsWithChildren {
  loader?: ReactNode
}

export const EnsureSegments = ({ children, loader = null }: EnsureSegmentsProps) => {
  const { listState } = useAppSelector(getSegments)

  const dispatch = useAppDispatch()

  useDidMountEffect(() => {
    const updateSegments = async () => {
      dispatch(segmentsActions.dropList())
      await dispatch(segmentsActions.getListFx())
    }

    updateSegments()
  })

  if (!listState.isLoaded) {
    return loader
  }

  return children
}
